import LocationControllerInterface from "@modules/common_module/LocationController/LocationControllerInterface";
import { Observable, map } from "rxjs";

const OBSERVED_PARAMS = ["gw-pending-reviews"];

class HashParamsProvider {
    params$: Observable<{ [key in (typeof OBSERVED_PARAMS)[number]]: boolean }>;

    constructor(
        private readonly locationController: LocationControllerInterface
    ) {
        this.params$ = this.locationController.selectHashParams().pipe(
            map((urlSearchParams) => {
                const result: Record<string, boolean> = {};

                for (const hashParamKey of urlSearchParams.keys()) {
                    for (const observedParam of OBSERVED_PARAMS) {
                        result[observedParam] =
                            hashParamKey.includes(observedParam);
                    }
                }

                return result as {
                    [key in (typeof OBSERVED_PARAMS)[number]]: boolean;
                };
            })
        );
    }

    selectParams() {
        return this.params$;
    }
}

export default HashParamsProvider;
